<ion-button slot="start"
  (tap)="onCancelButtonClick()"
  color="light"
  shape="round"
  class="modal-close-button">
  <i class="far fa-times-circle icon"></i>
</ion-button>

<ion-content [scrollEvents]="true" (swipe)="swipeHandler()">
  <div class="metadata-container" *ngIf="delivery$ | async as delivery">
    <div class="metadata-block"
        *ngIf="delivery && delivery.deliveryKeyCode; else noBlock"
        (tap)="tapModalHandler(delivery)">
      <div class="view-content image-content">
        <img [src]="getImage(delivery)" class="image image-cover"/>
        <div class="loader image-loader"></div>
      </div>

      <div class="metadata-wrapper">
        <p>{{delivery?.artistName}}</p>
        <p>{{delivery?.campaignName}}</p>
        <p>{{delivery?.businessLabelName}}</p>
        <p>Release Date: {{delivery?.releaseDate | date: 'MM/dd/YYYY'}}</p>
        <p>Expire Date: {{delivery?.expiryDate | date: 'MM/dd/YYYY'}}</p>
        <p>Contact: {{delivery?.contactName}}</p>
        <p>Type: {{delivery?.deliveryType}}</p>
      </div>
    </div>
  </div>

  <ng-template #noBlock>
    <img [src]="noImageUrl" class="image">
  </ng-template>
</ion-content>

<div class="loader" *ngIf="isLoading$ | async"></div>
